export const exhibitionOptions = [
  { label: 'Exibir proprietário', name: 'boExibirProprietario' },
  { label: 'Exibir acessibilidade', name: 'boExibirAcessibilidade' },
  { label: 'Exibir situação', name: 'boExibirSituacao' },
  { label: 'Exibir idade média no Resumo', name: 'boExibirIdadeMedia' },
];

export const vehicleSituationOptions = [
  { label: 'Ativos', value: 1 },
  { label: 'Inativos', value: 2 },
  { label: 'Todos', value: 3 },
];

export const vehicleInspectionOptions = [
  { label: 'Vistoriados', value: 1 },
  { label: 'Não vistoriados', value: 2 },
  { label: 'Todos', value: 3 },
];

export const utilizationOptions = [
  {label: "Nenhum", value: null},
  {label: "Sistema", value: "Sistema"},
  {label: "Serviços especiais", value: "Serviços especiais"},
]

export const groupingByOptions = [
  {label: "Agrupar por operador", value: 1},
  {label: "Agrupar por utilização", value: 2},
  {label: "Agrupar por classificação", value: 3}
]